import { render, staticRenderFns } from "./payment-method.vue?vue&type=template&id=226569d8&scoped=true"
import script from "./payment-method.vue?vue&type=script&lang=js"
export * from "./payment-method.vue?vue&type=script&lang=js"
import style0 from "./payment-method.vue?vue&type=style&index=0&id=226569d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226569d8",
  null
  
)

export default component.exports